import { List, CompanyRank, Show, DateCompany, CompanyList } from "../Components/index.js";

export default [
    {
        path: "/ration-strength-company",
        component: CompanyList,
        name: "ration-strength-company",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration-strength-company/:date/:company_id/:rank_id",
        component: CompanyRank,
        name: "ration-strength-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration-strength",
        component: List,
        name: "ration-strength-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration-strength/:date/show",
        component: Show,
        name: "ration-strength-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration-strength/:date/:company_id",
        component: DateCompany,
        name: "report.ration.rdc",
        meta: {
            requiresAuth: true,
        },
    },
];
